import { useState } from 'react'

// TODO: Refactor to generalize this component for better reuse
export function CardCollectionSearchControl(props = {}) {
	const {
		isEnabled = false,
		placeholder = 'Enter keywords',
		label = 'search',
		onChange
	} = props
	const [value, setValue] = useState('')

	const handleSearch = (e) => {
		// console.log('onSearch', e.target.value)
		onChange(value)
	}


	return isEnabled
		? (<label htmlFor="collection_search_input"
			className="grid items-center gap-4 grid-col-2-maxcontent">
			<span className="text-xs font-semibold text-black uppercase">{label}</span>
			<div className="grid items-center grid-flow-col p-0 border-0 border-b grid-cols-1fr-maxcontent">
				<input
					type="search"
					placeholder={placeholder}
					className="p-0 bg-transparent border-0 focus:outline-none focus:outline-0 focus:ring-0"
					onKeyPress={(event) => {
						if (event.key === 'Enter') {
							// console.log('Enter key pressed')
							onChange(value)
						}
					}}
					onChange={(e) => {
						// console.log('onChange', e.target.value)
						setValue(e.target.value)

					}
					}
					ref={element => (element || {}).onsearch = handleSearch}
				// onSearch={(e) => {
				// 	console.log('onSearch', e.target.value)
				// 	// onChange(e.target.value)
				// }}
				/>
				<button
					class="text-blue"
					onClick={(e) => { onChange(value) }}
				>
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" className="w-4 h-4 fill-current"><path d="M49.598 45.298l-13.4-13.3c2.7-3.8 4.1-8.6 3.4-13.7-1.2-8.6-8.2-15.4-16.9-16.2-11.8-1.2-21.8 8.8-20.6 20.7.8 8.6 7.6 15.7 16.2 16.9 5.1.7 9.9-.7 13.7-3.4l13.3 13.3c.6.6 1.5.6 2.1 0l2.1-2.1c.6-.6.6-1.6.1-2.2zm-41.6-24.4c0-7.1 5.8-12.9 12.9-12.9 7.1 0 12.9 5.8 12.9 12.9 0 7.1-5.8 12.9-12.9 12.9-7.1 0-12.9-5.7-12.9-12.9z" /></svg>
				</button>
			</div>
		</label>)
		: null
}

export default CardCollectionSearchControl
